<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title *ngIf="!userProvider.hasConfig(184)"> {{'Novo Pedido' | translate}} {{(getNomenclatura(tipoNomenclatura) | nomenclatura | async)}}</ion-title>

    <ion-title *ngIf="userProvider.hasConfig(184)">
      {{'Novo Pedido' | translate}} {{(getNomenclatura(tipoNomenclatura) | nomenclatura | async)}}
    </ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <ion-row class="ion-justify-content-center">
    <ion-col size="6" class="div-imagem-extendido alinhamento-center">
      <img [src]="pessoa.foto | image:' '" class="image" />
    </ion-col>
  </ion-row>

  <ion-row class="ion-justify-content-center">
    <ion-col>
      <h2 class="nome-pessoa">{{pessoa.id ? pessoa.nome : ("Nenhuma Pessoa Selecionada" | translate)}}</h2>
    </ion-col>
  </ion-row>

  <ion-row class="ion-justify-content-center">
    <ion-col size="6" class="alinhamento-center">
      <ion-button class="btn-default" type="button" (click)="selecionarPessoa();">
        {{ pessoa.id ? ("Alterar Pessoa" | translate) : ("Selecionar Pessoa" | translate)}}
      </ion-button>
    </ion-col>
  </ion-row>

  <ion-card-content class="remove-border">
    <form
      class="sample-form validations-form"
      [formGroup]="validations_form"
      (ngSubmit)="onSubmit(validations_form.value)"
    >
      <ion-grid>
        <ion-row>
          <ion-col size="1">
            <i class="fa-solid fa-hands-praying"></i>
          </ion-col>
          <ion-col size="auto">
            <ion-label>{{'Pedido de ' | translate}} {{'testemunho' | nomenclatura | async}} / {{'oracao' | nomenclatura | async}}</ion-label>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="texto">
            <ion-textarea rows="5" cols="60" type="text" formControlName="pedido"></ion-textarea>
          </ion-col>
        </ion-row>

        <div class="validation-errors">
          <ng-container *ngFor="let validation of validation_messages.pedido">
            <div
              class="error-message"
              *ngIf="validations_form.get('pedido')?.hasError(validation.type) && (validations_form.get('pedido')?.dirty || validations_form.get('pedido')?.touched)"
            >
              {{ validation.message }}
            </div>
          </ng-container>
        </div>

        <ion-row>
          <ion-col>
            <ion-label class="text-item">{{'Tipo' | translate}}</ion-label>
            <ion-select
              interface="action-sheet"
              placeholder="{{'Selecione o Tipo' | translate}}"
              cancelText="{{ 'Cancelar' | translate}}"
              okText="{{ 'Confirmar' | translate}}"
              formControlName="tipo"
            >
              <ion-select-option *ngFor="let t of tipos" [value]="t.id">{{t.nome}} </ion-select-option>
            </ion-select>
          </ion-col>
        </ion-row>

        <div class="validation-errors">
          <ng-container *ngFor="let validation of validation_messages.tipo">
            <div
              class="error-message"
              *ngIf="validations_form.get('tipo')?.hasError(validation.type) && (validations_form.get('tipo')?.dirty || validations_form.get('tipo')?.touched)"
            >
              {{ validation.message }}
            </div>
          </ng-container>
        </div>

        <ion-row>
          <ion-col>
            <ion-label class="text-item display">
              {{'Pedido público' | translate}}
              <ion-toggle [enableOnOffLabels]="true" [(ngModel)]="publico" formControlName="publico"></ion-toggle>
            </ion-label>
          </ion-col>
        </ion-row>
      </ion-grid>

      <ion-row class="ion-justify-content-center">
        <ion-col size="6">
          <ion-button
            class="btn-success btn-edit"
            expand="block"
            type="submit"
            [disabled]="!validations_form.valid || !pessoa.id || isSubmitting"
          >
            {{'Enviar' | translate}}</ion-button
          >
        </ion-col>
      </ion-row>
    </form>
  </ion-card-content>
  <ion-grid>
    <ion-row>
      <ion-col size="10" offset="1">
        <p class="text-info">
          {{'O usuário é o único responsável pelo conteúdo inserido no sistema, podendo ser responsabilizado administrativamente, civilmente e/ou criminalmente por quaisquer violações legais contidas no texto' | translate}}
        </p>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
